import { createIcon } from '@chakra-ui/react';

export default createIcon({
  displayName: 'SendHorizontalIcon',
  viewBox: '0 0 24 24',
  path: (
    <>
      <path d="M3.714 3.048a.498.498 0 0 0-.683.627l2.843 7.627a2 2 0 0 1 0 1.396l-2.842 7.627a.498.498 0 0 0 .682.627l18-8.5a.5.5 0 0 0 0-.904z" />
      <path d="M6 12h16" />
    </>
  ),
  defaultProps: {
    boxSize: 4,
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: 2,
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
  },
});
